export const PAGE_SIZE = 16;
export const PCC_CATEGORY_PAGE = 'PCC Category Page';
export const SUBCATEGORY_COOKIE = 'mypcc_pcc_redirect=1';
export const CATEGORY_PAGE_CANONICAL_URL =
  'https://parts.cat.com{seoURL}/category/{category}';
